<app-protected-content [requiredRoles]="requiredRoles">
  <div class="container" *transloco="let t; prefix: 'dsaManagement.emailTemplates'">
    <div class="panel">
      <div class="page-header">
        <div class="header-title-section">
          <h1 class="header-title">{{ t('title') }}</h1>
          <p class="header-subtitle">{{ t('list.subtitle') }}</p>
        </div>
      </div>

      <htx-table
        [data]="templates()"
        [columns]="columnConfig()"
        [loading]="loading()"
        [rowIdField]="'key'"
        emptyMessage="dsaManagement.emailTemplates.list.empty"
      ></htx-table>
    </div>
  </div>

  <ng-template #statusTemplate let-row>
    @let template = getTyped(row);
    <htx-badge
      [text]="
        (template.overridden
          ? 'dsaManagement.emailTemplates.list.status.overridden'
          : 'dsaManagement.emailTemplates.list.status.default') | transloco
      "
      [variant]="template.overridden ? 'warning' : 'secondary'"
    ></htx-badge>
  </ng-template>

  <ng-template #actionTemplate let-row>
    @let template = getTyped(row);
    <div class="action-buttons">
      <htx-button
        variant="tertiary"
        icon="edit"
        [iconOnly]="true"
        [tooltip]="'dsaManagement.emailTemplates.list.editAction' | transloco"
        (click)="edit(template)"
      ></htx-button>
    </div>
  </ng-template>
</app-protected-content>
